<template>
  <v-container
    fluid
  >
    <v-dialog
      v-model="dialog2"

      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card>
        <v-card-title class="text-h5 primary">
          <v-btn
            icon
            dark
            @click="dialog2 = false"
          >
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>  Choose {{ open_service }}
        </v-card-title>
        <v-card-text class="pt-4">
          <GetHotel :date="this.recordhotel.date_start_stay"></GetHotel>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog2 = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <v-dialog
          ref="dialog"
          v-model="modal"
          :return-value.sync="recordhotel.date_stay"
          persistent
          width="290px"
          @change="ProsesHitungHotel()"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="recordhotel.date_of_stay"
              label="Date Of Stay"
              dense
              outlined
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="recordhotel.date_of_stay"
            :min="new Date().toISOString().substr(0, 10)"
            scrollable
            range
            @change="CountDate()"
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="modal = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.dialog.save(recordhotel.date_of_stay)"
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
        <v-text-field
          :disabled="!recordhotel.date_start_stay"
          v-model="recordhotel.description"
          dense
          solo
          placeholder="Choose Hotel"
          label="Choose Hotel"
          outlined
          @click="OpenService('Guide')"
        />
        <v-text-field
          v-model="recordhotel.total_day_hotel"
          dense
          disabled
          placeholder="Total Day"
          label="Total Day"
        />
        <v-row>
          <v-col>
            <v-currency-field
              v-model="recordhotel.rates"
              prefix="Rp."
              hide-details
              type="number"
              dense
              disabled
              placeholder="Rates"
              label="Rates Room"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.cost_exbed"
              prefix="Rp."
              hide-details
              type="number"
              dense
              placeholder="Rates Exbed"
              label="Rates Exbed"
              disabled
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.cost_cnb"
              prefix="Rp."
              type="number"
              hide-details
              dense
              placeholder="Rates CNB"
              label="Rates CNB"
              disabled
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.cost_cwb"
              prefix="Rp."
              hide-details
              type="number"
              dense
              placeholder="Rates CWB"
              label="Rates CWB"
              disabled
            />
          </v-col>
        </v-row>
        <v-row v-if="wantmarkup">
          <v-col>
            <v-currency-field
              v-model="recordhotel.markup_room_only"
              hide-details
              type="number"
              dense
              placeholder="Markup Room Only"
              label="Markup Room Only "
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-if="recordhotel.qty_exbed > 0"
              v-model="recordhotel.markup_exbed"
              hide-details
              type="number"
              dense
              placeholder="Markup Exbed"
              label="Markup Exbed"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-if="recordhotel.qty_cnb > 0"
              v-model="recordhotel.markup_cnb"
              hide-details
              type="number"
              dense
              placeholder="Markup CNB"
              label="Markup CNB"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-if="recordhotel.qty_cwb > 0 "
              v-model="recordhotel.markup_cwb"
              hide-details
              type="number"
              dense
              placeholder="Markup CWB"
              label="Markup CWB"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12">
            <v-btn
              dense
              block
              text
              @click="wantmarkup=true"
            >
              Add Markup
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-currency-field
              v-model="recordhotel.qty_room_only"
              hide-details
              type="number"
              dense
              placeholder="Rates"
              label="Qty Room Only "
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.qty_exbed"
              hide-details
              type="number"
              dense
              placeholder="Rates Exbed"
              label="Qty Exbed"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.qty_cnb"
              hide-details
              type="number"
              dense
              placeholder="Rates CNB"
              label="Qty CNB"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.qty_cwb"
              hide-details
              type="number"
              dense
              placeholder="Rates CWB"
              label="Qty CWB"
              outlined
              @change="ProsesHitungHotel()"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-currency-field
              v-model="recordhotel.total_room_only"
              prefix="Rp."
              hide-details
              type="number"
              dense
              placeholder="Rates"
              label="Total Room Only "
              disabled
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.total_cnb "
              prefix="Rp."
              hide-details
              type="number"
              dense
              placeholder="Rates CNB"
              label="Total CNB"
              disabled
              @change="ProsesHitungHotel()"
            />
          </v-col>
          <v-col>
            <v-currency-field
              v-model="recordhotel.total_cwb"
              prefix="Rp."
              type="number"
              dense
              placeholder="Rates CWB"
              label="Total CWB"
              disabled
              @change="ProsesHitungHotel()"
            />
          </v-col>
        </v-row>

        <v-currency-field
          v-model="recordhotel.perpax_cnb"
          prefix="Rp."
          type="number"
          dense
          placeholder="Perpax CNB"
          label="Perpax CNB"
          disabled
        />

        <v-currency-field
          v-model="recordhotel.perpax_cwb"
          prefix="Rp."
          type="number"
          dense
          placeholder="Perpax CWB"
          label="Perpax CWB"
          disabled
        />
        <v-currency-field
          v-model="recordhotel.perpax_room_only"
          prefix="Rp."
          type="number"
          disabled
          dense
          placeholder="Perpax Adult"
          label="Perpax Adult"
        />
        <v-btn
          block
          class="primary"
          small
          @click="AddHotel()"
        >
          <span v-if="!statusedit"> Add Hotel</span>
          <span v-else>Edit Hotel</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col>
        <v-simple-table class="mb-2 mt-2">
          <thead>
            <tr>
              <td width="11%">
                Date Start
              </td>
              <td width="11%">
                Date End
              </td>
              <td> Detail Hotel</td>
              <td width="7%">
                Duration
              </td>
              <td width="11%">
                Total Cost
              </td>
              <td width="20%">
                Action
              </td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(dth,index3) in datahotel"
              :key="index3"
            >
              <td>{{ dth.date_start_stay }}</td>
              <td>{{ dth.date_end_stay }}</td>
              <td>{{ dth.description }}</td>
              <td>{{ dth.total_day_hotel }}</td>
              <td>RP.{{ Number(dth.total).toLocaleString() }}</td>
              <td>
                <v-btn
                  small
                  class="primary"
                  @click="EditHotel(index3)"
                >
                  <v-icon>
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
                <v-btn
                  small
                  class="error ml-1"
                  @click="DeleteHotel(index3)"
                >
                  <v-icon>
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'
import moment from 'moment'
import axios from 'axios'
import GetHotel from '../get-data/get-hotel.vue'

export default {
  components: { GetHotel },
  props: ['datainvoice'],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      wantmarkup: false,
      wantnote: false,
      dialog2: false,
      dialog3: false,
      recordhotel: {
        note_hotel: '',
        date_of_stay: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        date_start_stay: '',
        date_end_stay: '',
        total_day_hotel: 0,
        description: '',
        type: 'Hotel',
        id_service: 0,
        id_activity: 0,
        rates: 0,
        cost_cnb: 0,
        cost_cwb: 0,
        cost_exbed: 0,
        qty_adult_awal: 0,
        qty_adult: 0,
        qty_cnb_awal: 0,
        qty_cnb: 0,
        qty_cwb_awal: 0,
        qty_cwb: 0,
        qty_exbed: 0,
        qty_room_only: 0,
        qty: 0,
        markup_cnb: 0,
        markup_cwb: 0,
        markup_exbed: 0,
        markup_room_only: 0,
        markup: 0,
        total_cnb: 0,
        total_cwb: 0,
        total_room_only: 0,
        total: 0,
        perpax_cnb: 0,
        perpax_cwb: 0,
        perpax_exbed: 0,
        perpax_room_only: 0,
        perpax: 0,
      },
      datahotel: [],
      editindex: '',
      statusedit: false,
      open_service: false,
    }
  },
  mounted() {
    // eslint-disable-next-line radix
    this.$root.$on('MakeHotel', data => {
      this.AddItinerary(data)
      this.dialog2 = false
    })
  },
  created() {
    if (this.$route.query.id_tour) {
      this.getDataEditTour()
    }
  },
  methods: {
    UpdateQty() {
      // eslint-disable-next-line radix
      this.recordhotel.qty_cnb = 0
      // eslint-disable-next-line radix
      this.recordhotel.qty_cwb = 0
      // eslint-disable-next-line radix
      this.recordhotel.qty_room_only = 0
    },
    EditHotel(index) {
      const data = this.datahotel[index]
      this.recordhotel = data
      this.editindex = index
      this.statusedit = true
    },
    DeleteHotel(index) {
      this.$delete(this.datahotel, index)
    },
    AddHotel() {
      if (this.recordhotel.total_day_hotel <= 0) {
        this.$root.$emit('PesanResponse', 'Please specify length of stay', 'red')
      } else {
        if (this.statusedit) {
          this.datahotel[this.editindex] = this.recordhotel
          this.editindex = ''
          this.statusedit = false
        } else {
          this.datahotel.push(this.recordhotel)
        }
        this.$root.$emit('HitungHotel', this.datahotel)
        this.recordhotel = {
          date_of_stay: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          date_start_stay: '',
          date_end_stay: '',
          total_day_hotel: 0,
          description: '',
          type: 'Hotel',
          id_service: 0,
          id_activity: 0,
          rates: 0,
          cost_cnb: 0,
          cost_cwb: 0,
          cost_exbed: 0,
          qty_adult_awal: 0,
          qty_adult: 0,
          qty_cnb_awal: 0,
          qty_cnb: 0,
          qty_cwb_awal: 0,
          qty_cwb: 0,
          qty_exbed: 0,
          qty_room_only: 0,
          qty: 0,
          markup_cnb: 0,
          markup_cwb: 0,
          markup_exbed: 0,
          markup_room_only: 0,
          markup: 0,
          total_cnb: 0,
          total_cwb: 0,
          total_room_only: 0,
          total: 0,
          perpax_cnb: 0,
          perpax_cwb: 0,
          perpax_exbed: 0,
          perpax_room_only: 0,
          perpax: 0,
        }
      }
      this.$root.$emit('CountPerpax')
    },
    ProsesHitungHotel() {
      this.render = false
      // eslint-disable-next-line radix
      this.recordhotel.total_exbed = (parseInt(this.recordhotel.cost_exbed) + parseInt(this.recordhotel.markup_exbed)) * parseInt(this.recordhotel.qty_exbed)
      // eslint-disable-next-line radix
      this.recordhotel.total_room_only = ((parseInt(this.recordhotel.rates) + parseInt(this.recordhotel.markup_room_only)) * parseInt(this.recordhotel.qty_room_only) + parseInt(this.recordhotel.total_exbed)) * this.recordhotel.total_day_hotel
      // eslint-disable-next-line radix
      this.recordhotel.perpax_room_only = (parseInt(this.recordhotel.total_room_only)) / parseInt(this.recordhotel.qty_adult)
      // eslint-disable-next-line radix
      this.recordhotel.total_cnb = ((parseInt(this.recordhotel.cost_cnb) + parseInt(this.recordhotel.markup_cnb)) * parseInt(this.recordhotel.qty_cnb)) * this.recordhotel.total_day_hotel

      if (this.$store.state.dataitinerari.total_cnb > 0) {
        // eslint-disable-next-line radix
        this.recordhotel.perpax_cnb = (parseInt(this.recordhotel.total_cnb) / parseInt(this.$store.state.dataitinerari.total_cnb))
      } else {
        this.recordhotel.perpax_cnb = 0
      }
      // eslint-disable-next-line radix
      this.recordhotel.total_cwb = ((parseInt(this.recordhotel.cost_cwb) + parseInt(this.recordhotel.markup_cwb)) * parseInt(this.recordhotel.qty_cwb)) * this.recordhotel.total_day_hotel
      // eslint-disable-next-line radix

      if (this.$store.state.dataitinerari.total_cwb > 0) {
      // eslint-disable-next-line radix
        this.recordhotel.perpax_cwb = (parseInt(this.recordhotel.total_cwb) / parseInt(this.$store.state.dataitinerari.total_cwb))
      } else {
        this.recordhotel.perpax_cwb = 0
      }

      this.render = true
      // eslint-disable-next-line radix
      this.recordhotel.markup = parseInt(this.recordhotel.markup_room_only) + parseInt(this.recordhotel.markup_exbed) + parseInt(this.recordhotel.markup_cnb) + parseInt(this.recordhotel.markup_cwb)
      // eslint-disable-next-line radix
      this.recordhotel.qty = parseInt(this.recordhotel.qty_room_only) + parseInt(this.recordhotel.qty_cnb) + parseInt(this.recordhotel.qty_cwb) + parseInt(this.recordhotel.qty_exbed)
      // eslint-disable-next-line radix
      this.recordhotel.total = parseInt(this.recordhotel.total_room_only) + parseInt(this.recordhotel.total_cnb) + parseInt(this.recordhotel.total_cwb)
      // eslint-disable-next-line radix
      this.recordhotel.perpax = parseInt(this.recordhotel.perpax_room_only) + parseInt(this.recordhotel.perpax_cnb) + parseInt(this.recordhotel.perpax_cwb)
    },

    CountDate() {
      // eslint-disable-next-line prefer-destructuring
      this.recordhotel.date_end_stay = this.recordhotel.date_of_stay[1]
      // eslint-disable-next-line prefer-destructuring
      this.recordhotel.date_start_stay = this.recordhotel.date_of_stay[0]

      const start = moment(this.recordhotel.date_end_stay, 'YYYY-MM-DD')
      const end = moment(this.recordhotel.date_start_stay, 'YYYY-MM-DD')
      const a = moment.duration(start.diff(end)).asDays()
      this.recordhotel.total_day_hotel = a

      this.ProsesHitungHotel()

      //    const date = moment(this.forminvoice.travel_date, 'YYYY-MM-DD').add(this.forminvoice.total_day, 'days').format('YYYY-MM-DD')
    //  this.forminvoice.end_travel_date = date
    },
    CountCostItinerary() {
      let grandtotala = 0
      this.itinerary.data.forEach(number => {
        let grandtotalb = 0
        number.details.forEach(data => {
          // eslint-disable-next-line no-const-assign, radix
          grandtotalb += parseInt(data.total)
        })
        // eslint-disable-next-line no-const-assign, radix
        grandtotala += parseInt(grandtotalb)
        // eslint-disable-next-line no-const-assign
      //  grandtotal += number.total
      })
      this.itinerary.grandtotalitinerary = grandtotala
    },
    CekDialog() {
      this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
      this.recordhotel = {
        detail: this.datainvoice,
        time: '',
        category: '',
        description: '',
        cost_for_adult: 0,
        cost_for_child: 0,
        cost: 0,
        qty_adult: 0,
        qty_child: 0,
        qty: 0,
        markup_adult: 0,
        markup_child: 0,
        markup: 0,
        total_adult: 0,
        total_child: 0,
        total: 0,
        perpax_adult: 0,
        perpax_child: 0,
        perpax: 0,
        grand_total: 0,
      }
      this.dialog3 = false
      this.CountCostItinerary()
    },

    AddItinerary(data) {
      this.recordhotel.description = `${data.hotel_name} Type Room ${data.type_room}`
      this.recordhotel.type = 'Hotel'
      this.recordhotel.id_service = data.id_service
      this.recordhotel.id_activity = data.id_hotel
      // eslint-disable-next-line radix
      this.recordhotel.rates = parseInt(data.rates)
      // eslint-disable-next-line radix
      this.recordhotel.cost_cnb = parseInt(data.cob)
      // eslint-disable-next-line radix
      this.recordhotel.cost_cwb = parseInt(data.cwob)
      // eslint-disable-next-line radix
      this.recordhotel.cost_exbed = parseInt(data.exbed)
      // eslint-disable-next-line radix
      // eslint-disable-next-line radix
      this.recordhotel.qty_adult_awal = parseInt(this.datainvoice.total_adult)
      // eslint-disable-next-line radix
      this.recordhotel.qty_adult = parseInt(this.datainvoice.total_adult)
      // eslint-disable-next-line radix
      this.recordhotel.qty_cnb_awal = parseInt(this.datainvoice.total_cnb)
      // eslint-disable-next-line radix
      this.recordhotel.qty_cnb = parseInt(this.datainvoice.total_cnb)
      // eslint-disable-next-line radix
      this.recordhotel.qty_cwb_awal = parseInt(this.datainvoice.total_cwb)
      // eslint-disable-next-line radix
      this.recordhotel.qty_cwb = parseInt(this.datainvoice.total_cwb)
      // eslint-disable-next-line radix
      this.recordhotel.qty_exbed = 0
      // eslint-disable-next-line radix
      this.recordhotel.qty_room_only = parseInt(this.datainvoice.total_adult)
      // eslint-disable-next-line radix
      this.recordhotel.qty = parseInt(this.datainvoice.total_pax)
      this.recordhotel.markup_cnb = 0
      this.recordhotel.markup_cwb = 0
      this.recordhotel.markup_exbed = 0
      this.recordhotel.markup_room_only = 0
      this.recordhotel.markup = 0
      this.recordhotel.total_cnb = 0
      this.recordhotel.total_cwb = 0
      // eslint-disable-next-line radix
      this.recordhotel.total_room_only = data.rates * parseInt(this.datainvoice.total_adult)
      this.recordhotel.total = 0
      this.recordhotel.perpax_cnb = 0
      this.recordhotel.perpax_cwb = 0
      this.recordhotel.perpax_exbed = 0
      this.recordhotel.perpax_room_only = 0
      this.recordhotel.perpax = 0
      this.ProsesHitungHotel()
    },
    ChangeQty() {
      // eslint-disable-next-line radix
      this.travelcost.record_guide.per_pax = parseInt(Math.round(this.travelcost.record_guide.total / this.datainvoice.total_adult))

      this.travelcost.details.forEach((element, index) => {
        if (this.travelcost.details[index].category === 'Variable Cost') {
        // eslint-disable-next-line radix
          this.travelcost.details[index].per_pax = Math.round(parseInt(this.travelcost.details[index].total) / parseInt(this.datainvoice.total_adult))
        } else {
        // eslint-disable-next-line radix
          this.travelcost.details[index].per_pax = Math.round(parseInt(this.travelcost.details[index].total) / parseInt(this.datainvoice.total_pax))
        }
      })
      this.CountCostTravel()
    },
    getDataEditTour() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/getDataEditHotel', { id_tour: this.$route.query.id_tour }).then(response => {
        if (response.data.data.length > 0) {
          this.datahotel = response.data.data
          this.ProsesHitungHotel()
        }
        this.$root.$emit('HitungHotel', this.datahotel)
        this.$root.$emit('PesanResponse', response.data.message, 'primary')

        //     this.CountCostTravel()
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    DeleteRecordGuide() {
      this.travelcost.record_guide = {
        id_guide: '',
        description: '',
        cost: 0,
        duration: this.datainvoice.total_day,
        total: 0,
        per_pax: 0,
      }
      this.CountCostTravel()
    },
    OpenService(nameservice) {
      this.open_service = nameservice
      this.dialog2 = true
    },
    AddCostVariable(data, type) {
      if (type === 'Other') {
        this.recordtravelcost.id_other = data.id_other
        this.recordtravelcost.type = type
        this.recordtravelcost.description = data.other_name
        this.recordtravelcost.category = data.category
        // eslint-disable-next-line radix
        this.recordtravelcost.cost = parseInt(data.rate)
      }
      if (type === 'Guide') {
        this.travelcost.record_guide.description = `Guide - ${data.guide_name}`
        this.travelcost.record_guide.id_guide = data.id_guide
        this.travelcost.record_guide.cost = data.rate
        this.travelcost.record_guide.duration = 1
        this.travelcost.record_guide.total = data.rate
        // eslint-disable-next-line radix
        this.travelcost.record_guide.per_pax = parseInt(Math.round(this.travelcost.record_guide.total / this.datainvoice.total_adult))
      }
      this.ChangeTotal()
    },
    DeleteTravelCost(index) {
      //  this.travelcost.details.splice(this.travelcost.details.indexOf(index), 1)
      this.$delete(this.travelcost.details, index)
      this.CountCostTravel()
    },
    ChangeTotalGuide() {
      // eslint-disable-next-line radix
      this.travelcost.record_guide.total = parseInt(this.travelcost.record_guide.cost) * parseInt(this.travelcost.record_guide.duration)
      // eslint-disable-next-line radix
      this.travelcost.record_guide.per_pax = Math.round(parseInt(this.travelcost.record_guide.total) / parseInt(this.datainvoice.total_adult))
      this.CountCostTravel()
    },
    ChangeTotal() {
      if (this.recordtravelcost.qty < 1 || this.recordtravelcost.nt < 1) {
        this.recordtravelcost.qty = 1
        this.recordtravelcost.nt = 1
        // eslint-disable-next-line radix
        this.recordtravelcost.total = parseInt(this.recordtravelcost.cost) * parseInt(this.recordtravelcost.qty) * parseInt(this.recordtravelcost.nt)
        this.$root.$emit('PesanResponse', 'Minimal Qty dan Nt 1', 'red')
        // eslint-disable-next-line radix
      } else {
        // eslint-disable-next-line radix
        this.recordtravelcost.total = parseInt(this.recordtravelcost.cost) * parseInt(this.recordtravelcost.qty) * parseInt(this.recordtravelcost.nt)
        // eslint-disable-next-line radix
      }

      if (this.recordtravelcost.category === 'Variable Cost') {
        // eslint-disable-next-line radix
        this.recordtravelcost.per_pax = Math.round(parseInt(this.recordtravelcost.total) / parseInt(this.datainvoice.total_adult))
      } else {
        // eslint-disable-next-line radix
        this.recordtravelcost.per_pax = Math.round(parseInt(this.recordtravelcost.total) / parseInt(this.datainvoice.total_pax))
      }
      this.CountCostTravel()
    },
    ChangeTotalInput(index) {
      if (this.travelcost.details[index].category === 'Variable Cost') {
        // eslint-disable-next-line radix
        this.travelcost.details[index].per_pax = Math.round(parseInt(this.travelcost.details[index].total) / parseInt(this.datainvoice.total_adult))
      } else {
        // eslint-disable-next-line radix
        this.travelcost.details[index].per_pax = Math.round(parseInt(this.travelcost.details[index].total) / parseInt(this.datainvoice.total_pax))
      }

      if (this.travelcost.details[index].qty < 1 || this.travelcost.details[index].nt < 1) {
        this.travelcost.details[index].qty = 1
        this.travelcost.details[index].nt = 1
        this.travelcost.details[index].total = this.travelcost.details[index].cost * this.travelcost.details[index].qty * this.travelcost.details[index].nt
        this.$root.$emit('PesanResponse', 'Minimal Qty dan Nt 1', 'red')
      } else {
        this.travelcost.details[index].total = this.travelcost.details[index].cost * this.travelcost.details[index].qty * this.travelcost.details[index].nt
        this.travelcost.details[index].per_pax = Math.round(this.travelcost.details[index].total / this.datainvoice.total_pax)
      }
      this.CountCostTravel()
    },
    AddCostTravel() {
      this.travelcost.details.push(this.recordtravelcost)
      this.recordtravelcost = {
        id_other: '',
        category: '',
        description: '',
        cost: '',
        qty: 1,
        nt: 1,
        total: '',
        per_pax: '',
      }
      this.CountCostTravel()
    },
    CountCostTravel() {
      this.travelcost.grandtotaltravelcost = 0
      this.travelcost.grandtotaltravelcostperpax = 0
      let grandtotal = 0
      let grandtotalperpax = 0
      this.travelcost.details.forEach(number => {
        // eslint-disable-next-line no-const-assign
        grandtotal += number.total
        grandtotalperpax += number.per_pax
      })
      // eslint-disable-next-line radix
      if (this.travelcost.record_guide.total) {
        // eslint-disable-next-line radix
        this.travelcost.grandtotaltravelcost = parseInt(grandtotal) + parseInt(this.travelcost.record_guide.total)
        // eslint-disable-next-line radix
        this.travelcost.grandtotaltravelcostperpax = parseInt(grandtotalperpax) + parseInt(this.travelcost.record_guide.per_pax)
      } else {
        // eslint-disable-next-line radix
        this.travelcost.grandtotaltravelcost = parseInt(grandtotal)
        // eslint-disable-next-line radix
        this.travelcost.grandtotaltravelcostperpax = parseInt(grandtotalperpax)
      }
    },
  },
}
</script>
